/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function Size1() {
  const { id } = useParams();

  const [sizeId, setsizeId] = useState("");

  useEffect(() => {
    setsizeId(id);
    console.log(sizeId);
  }, [id]);
  console.log(sizeId);

  return (
    <div className="enhancements prices">
      <main>
        <div>
          <div className="container ">
            <div className="tp-trend-product-5__top-mb"></div>
            <div className="row">
              <div
                className="tab-content"
                id="nav-tabContent"
                style={{ backgroundColor: "#fefefb" }}
              >
                <div
                  className="tab-pane fade active show"
                  role="tabpanel"
                  aria-labelledby="nav-Cards-tab"
                  tabIndex={0}
                >
                  {/* Single Canvas Start */}
                  {sizeId === "1" && (
                    <div id="nav-Cards">
                      <div className="row text text-left ">
                        <div className="col-xl-12 col-lg-12 col-md-12 text-left">
                          <h4 className="text-left second">Single Canvas</h4>
                        </div>
                      </div>
                      <div className="tp-feature-top-4__border">
                        <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-1 row-cols-sm-2 mt-50">
                          <div className="two">
                            <div className="nice-select select" tabIndex={0}>
                              <span className="current">Quantity 1</span>
                              <ul className="list">
                                <li
                                  data-value="Quantity 1"
                                  className="option selected"
                                >
                                  Quantity 1
                                </li>
                                <li data-value={2} className="option">
                                  Quantity 2
                                </li>
                                <li data-value={3} className="option">
                                  Quantity 3
                                </li>
                                <li data-value={4} className="option">
                                  Quantity 4
                                </li>
                                <li data-value={5} className="option">
                                  Quantity 5
                                </li>
                                <li data-value={6} className="option">
                                  Quantity 6
                                </li>
                                <li data-value={7} className="option">
                                  Quantity 7
                                </li>
                                <li data-value={8} className="option">
                                  Quantity 8
                                </li>
                                <li data-value={9} className="option">
                                  Quantity 9
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="col mb-30">
                            <div className="tp-feature-top-4__item ab next text-center">
                              <img
                                src="assets/img/breadcrumb/taable-image-1.png"
                                alt=""
                              />
                              {/* <span class=" ">Thin gallery wrap (0.75)</span>  */}
                            </div>
                          </div>
                          <div className="col mb-30">
                            <div className="tp-feature-top-4__item ab text-center">
                              <img
                                src="assets/img/breadcrumb/taable-image-2.png"
                                alt=""
                              />
                              {/* <span class=" ">Thick gallery wrap (1.5)</span> */}
                            </div>
                          </div>
                          <div className="col mb-30">
                            <div className="tp-feature-top-4__item ab text-center">
                              <img
                                src="assets/img/breadcrumb/taable-image-3.png"
                                alt=""
                              />
                              {/* <span class=" " style="margin-left:59px;">Framed</span> */}
                            </div>
                          </div>
                          <div className="col mb-30">
                            <div className="tp-feature-top-4__item ab text-center">
                              <img
                                src="assets/img/breadcrumb/taable-image-4.png"
                                alt=""
                              />
                              {/* <span class=" ">Rolled in a tube</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* price table start */}
                      <div className="Section3 pt-30">
                        <div className="container">
                          <div className="DataTable1 table-sm table-responsive">
                            <table className="table table-striped first">
                              <thead>
                                <tr>
                                  <th scope="col" />
                                  <th scope="col">Thin gallery wrap (0.75)</th>
                                  <th scope="col">Thick gallery wrap (1.5)</th>
                                  <th scope="col">Framed</th>
                                  <th scope="col">Rolled in a tube</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td scope="row">6 - 8 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">8 - 8 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">8 - 10 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">10 -10 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">
                                    10 -10 " |&nbsp;
                                    <span
                                      style={{
                                        color: "var(--tp-common-purple-2)",
                                      }}
                                    >
                                      Popular
                                    </span>
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">10 -10 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">
                                    10 -10 " |&nbsp;
                                    <span
                                      style={{
                                        color: "var(--tp-common-purple-2)",
                                      }}
                                    >
                                      Popular
                                    </span>
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">10 -10 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">10 -10 "</td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                  <td>
                                    $14.95
                                    <input
                                      style={{ marginLeft: "50%" }}
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="text-center my-5">
                            <NavLink
                              to={"/create-print/edge"}
                              className="btn btn-primary btn-lg active fw-bold px-5"
                              style={{ borderRadius: 0 }}
                              role="button"
                              aria-pressed="true"
                            >
                              Next
                            </NavLink>
                          </div>
                        </div>
                      </div>
                      {/* price table end */}
                    </div>
                  )}
                  {/* Single Canvas End */}
                  {/* Split Canvas Start */}
                  {sizeId === "2" && (
                    <div
                      id="nav-Books"
                      className="Section3 pt-50 pb-50 two"
                      data-background="assets/img/breadcrumb/Prices-two.png"
                      style={{
                        backgroundImage:
                          "url(assets/img/breadcrumb/Prices-two.png)",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div className="container">
                        <div className="row text text-left ">
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <h4 className="text-left second">Split Canvas</h4>
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-12 text-right">
                            <div className="nice-select select" tabIndex={0}>
                              <span className="current">Quantity 1</span>
                              <ul className="list">
                                <li
                                  data-value="Quantity 1"
                                  className="option selected"
                                >
                                  Quantity 1
                                </li>
                                <li data-value={2} className="option">
                                  Quantity 2
                                </li>
                                <li data-value={3} className="option">
                                  Quantity 3
                                </li>
                                <li data-value={4} className="option">
                                  Quantity 4
                                </li>
                                <li data-value={5} className="option">
                                  Quantity 5
                                </li>
                                <li data-value={6} className="option">
                                  Quantity 6
                                </li>
                                <li data-value={7} className="option">
                                  Quantity 7
                                </li>
                                <li data-value={8} className="option">
                                  Quantity 8
                                </li>
                                <li data-value={9} className="option">
                                  Quantity 9
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <h4 className="text-left second-text">
                              DYPTYCHS - 2 PANELS
                            </h4>
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table table-striped two">
                                <thead>
                                  <tr>
                                    <th scope="col">DYPTYCHS 2 PANELS</th>
                                    <th scope="col">STANDARD 3/4</th>
                                    <th scope="col">THICK 1 1/2</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>36"x24"(2-18x24 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>$220.00</td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <h4 className="text-left second-text">
                              DYPTYCHS - 3 PANELS
                            </h4>
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table table-striped two">
                                <thead>
                                  <tr>
                                    <th scope="col">DYPTYCHS 2 PANELS</th>
                                    <th scope="col">STANDARD 3/4</th>
                                    <th scope="col">THICK 1 1/2</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>36"x24"(2-18x24 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>$220.00</td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>46"x30"(2-23x30 panels)</td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                    <td>
                                      $220.00
                                      <input
                                        style={{ marginLeft: "24%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="text-center my-5">
                          <NavLink
                            to={"edge"}
                            className="btn btn-primary btn-lg active fw-bold px-5"
                            style={{ borderRadius: 0 }}
                            role="button"
                            aria-pressed="true"
                          >
                            Next
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Split Canvas End */}
                  {/* Gallery Walls Start */} {/* fourth section */}
                  {sizeId === "3" && (
                    <div className="Section3 pt-50 pb-50 two" id="nav-Cloths">
                      <div className="container">
                        <div className="row text text-left ">
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <h4 className="text-left second">Gallery Walls</h4>
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <p className="fourth-section">
                              We have Created 10 different Gallery Walls. These
                              Artistic displays enhance your Life with your
                              wonderful memories. Gallery Walls are 10% less
                              expensive if those canvases were purchased
                              individually.
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <img
                              src="assets/img/breadcrumb/image-fourth.png"
                              alt=""
                            />
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-6 text-left">
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table   ">
                                <thead>
                                  <tr>
                                    <th scope="col" style={{ border: "none" }}>
                                      Select one
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x24: $380.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x32: $420.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 48x40: $480.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 50x44: $488.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      6-piece 56x44: $610.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x24: $380.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x32: $420.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 48x40: $480.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 50x44: $488.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      6-piece 56x44: $610.00
                                      <input
                                        style={{ marginLeft: "10%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="col-xl-2 col-lg-2 col-md-6 text-left">
                            <div className="two-col-text">
                              <p>
                                {" "}
                                (2) 8 x 12 Thick wrap (1) 17 x 11 Thick wrap (1)
                                16 x 24 Thick wrap 34x24 overall
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="text-center my-5">
                          <NavLink
                            to={"edge"}
                            className="btn btn-primary btn-lg active fw-bold px-5"
                            style={{ borderRadius: 0 }}
                            role="button"
                            aria-pressed="true"
                          >
                            Next
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Gallery Walls End */} {/* fourth section */}
                  {/* Story Canvas Start */} {/* fifth section */}
                  {sizeId === "4" && (
                    <div
                      id="nav-Invitation"
                      className="Section3 pt-50 pb-50 two"
                      data-background="assets/img/breadcrumb/Prices-two-1.png"
                      style={{
                        backgroundImage:
                          'url("assets/img/breadcrumb/Prices-two-1.png")',
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div className="container">
                        <div className="row text text-left ">
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <h4 className="text-left second">Story Canvas</h4>
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <p className="fourth-section">
                              We have Created 20 different Story Canvas. These
                              Artistic displays enhance your Life with your
                              wonderful memories.
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 col-lg-6 col-md-12 text-left">
                            <img
                              src="assets/img/breadcrumb/image-fourth1.png"
                              alt=""
                            />
                          </div>
                          <div className="col-xl-3 col-lg-3 col-md-6 text-left">
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table   ">
                                <thead>
                                  <tr>
                                    <th scope="col" style={{ border: "none" }}>
                                      Select one
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x24: $380.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x32: $420.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 48x40: $480.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 50x44: $488.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      6-piece 56x44: $610.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x24: $380.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x32: $420.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 48x40: $480.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 50x44: $488.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      6-piece 56x44: $610.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table   ">
                                <thead>
                                  <tr>
                                    <th scope="col" style={{ border: "none" }}>
                                      Background Color
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      White Background
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-3 col-md-6 text-left">
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table   ">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{ border: "none", opacity: 0 }}
                                    >
                                      Select one
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x24: $380.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x32: $420.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 48x40: $480.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 50x44: $488.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      6-piece 56x44: $610.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x24: $380.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      4-piece 34x32: $420.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 48x40: $480.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      5-piece 50x44: $488.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      6-piece 56x44: $610.00
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="DataTable1 table-sm table-responsive">
                              <table className="table   ">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{ border: "none", opacity: 0 }}
                                    >
                                      White Background
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ border: "none" }}>
                                      Black Background
                                      <input
                                        style={{ marginLeft: "8%" }}
                                        type="radio"
                                        aria-label="Radio button for following text input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="text-center my-5">
                            <NavLink
                              to={"edge"}
                              className="btn btn-primary btn-lg active fw-bold px-5"
                              style={{ borderRadius: 0 }}
                              role="button"
                              aria-pressed="true"
                            >
                              Next
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Story Canvas End */} {/* fifth section */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
